import {observer} from 'mobx-react';

import {Body1} from '../../../../../../../ui/atoms/typography';

import {ContentBox} from '../../admin-workspace-styled';
import {FlexRowEnd} from '@ui/style/styles';
import {SwitchToggle} from '@ui/molecules/toggle-switch/toggle-switch';
import {Routes, Route} from 'react-router';
import {useAdminCheckinsHook} from './admin-checkins.hooks';
import {useEffect, useState} from 'react';
import {capitalize} from '@utils';
import {checkinName} from '@utils/checkin-name';

export const AdminCheckins = observer(({subTab}: {subTab?: string}) => {
  const {
    isCheckinsEnabled,
    editCheckins,
    handleToggleCheckins,
  } = useAdminCheckinsHook();

  const [checkinsChecked, setCheckinsChecked] = useState(isCheckinsEnabled);

  useEffect(() => {
    if (subTab && subTab === 'configure') {
      editCheckins();
    }
  }, [editCheckins, subTab]);

  return (
    <>
      <Routes>
        <Route path="">
          <ContentBox>
            <div className="flex">
              <div className="column">
                <Body1 kind="textDark" weight="bold">
                  {capitalize(checkinName())}s
                </Body1>
              </div>
              <FlexRowEnd className="">
                <SwitchToggle
                  onChange={(e: any) => {
                    if (isCheckinsEnabled) {
                      setCheckinsChecked(false);
                    } else {
                      setCheckinsChecked(true);
                    }
                    handleToggleCheckins(
                      e,
                      isCheckinsEnabled ? 'disabled' : 'enabled',
                    );
                  }}
                  checked={checkinsChecked}
                  defaultChecked={isCheckinsEnabled}
                />
              </FlexRowEnd>
            </div>
          </ContentBox>
        </Route>
      </Routes>
    </>
  );
});
